/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 */
import { api } from '../../../config/api';

import type { BlockDaysApiArg, OverrideData } from '../types';

const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    blockDays: build.mutation<OverrideData, BlockDaysApiArg>({
      query: (queryArg) => ({
        body: queryArg.body,
        method: 'POST',
        url: `/v1/slots/block-day`,
      }),
    }),
  }),
  overrideExisting: true,
});

export { injectedRtkApi as blockDaysApi };
export const { useBlockDaysMutation } = injectedRtkApi;
